module.exports = __webpack_public_path__ + "static/media/peter.633bcaef.jpg";